import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import ModalTaskEdit from 'app/components/company-admin/grant-system/modal-task-edit';
import WorkflowCols  from 'app/components/company-admin/grant-system/workflow-cols';
import helpers       from 'app/helpers/grant-system';
import EntitiesSlx   from 'app/selectors/entities';



class WorkflowAssignees extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      modal: null,
    };

    this.onClickTask = this.onClickTask.bind(this);
    this.onCloseTask = this.onCloseTask.bind(this);
  }

  onClickTask(stage, task, event) {
    event && event.preventDefault();
    this.setState({modal: [stage, task]});
  }
  onCloseTask() {
    this.setState({modal: null});
  }

  renderBelow(stage) {
    const {empMap, showEmpCount} = this.props;
    return (
      <div className="ca-gwf-ass-stage">
        {stage.tasks.map((task) => {
          const emps = task.employeeIds.map(id => empMap[id]).filter(emp => emp);
          const showEmps = emps.slice(0, showEmpCount);
          const moreCount = Math.max(emps.length - showEmpCount, 0);
          const hasNone = !emps.length;
          const typeLabel = helpers.taskMetaLabel(task);
          return (
            <div key={task.id} className="ca-gwf-ass-task">
              <div className="ca-gwf-ass-task-type">{typeLabel}</div>
              <div className="ca-gwf-ass-task-title">{task.title}</div>
              <div className="ca-gwf-ass-task-assignees">
                {showEmps.map((emp) => {
                  return (
                    <div key={emp.id} className="ca-gwf-ass-task-assignee">{`${emp.firstName} ${emp.lastName}`}</div>
                  );
                })}
                {!!moreCount && (
                  <div className="ca-gwf-ass-task-assignee _italic _clr-slate">{`...and ${moreCount} more`}</div>
                )}
                {hasNone && (
                  <div className="ca-gwf-ass-task-assignee _italic _clr-slate">No assignees yet</div>
                )}
                <div className="ca-gwf-ass-task-assignee">
                  <a href="#" onClick={this.onClickTask.bind(this, stage, task)} className="blue-pink-hover">Manage Assignees</a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const {workflow, className, minColWidth} = this.props;
    const {modal} = this.state;

    return (<>
      <WorkflowCols workflow={workflow} className={`ca-gwf-ass ${className}`} minColWidth={minColWidth} renderBelow={this.renderBelow.bind(this)} />
      {!!modal && (
        <ModalTaskEdit assigneesOnly workflow={workflow} stage={modal[0]} task={modal[1]} onClose={this.onCloseTask} />
      )}
    </>);
  }

}

WorkflowAssignees.propTypes = {
  workflow: PropTypes.object.isRequired,
  className: PropTypes.string,
  showEmpCount: PropTypes.number,
  minColWidth: PropTypes.number,
};
WorkflowAssignees.defaultProps = {
  className: '',
  showEmpCount: 12,
  minColWidth: 340,
};

const stateToProps = (state) => ({
  empMap: EntitiesSlx.employees(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(WorkflowAssignees);
